export default function RecoveryPointObjectivesDirective() {
  return {
    template: require('./recovery-point-objectives.html'),
    require: '^form',
    scope: {
      process: '=',
      isEditable: '=',
      tooltipAppendToSelector: '@',
    },
    controller: 'RecoveryPointObjectivesController',
    controllerAs: 'recoveryPointObjectivesVM',
    bindToController: true,
    replace: true,
  };
}
